<template>
  <div class="auth-page md-layout md-alignment-center-center">

    <form novalidate
          class="auth-page__form
                 md-layout
                 md-alignment-center-center"
          @submit.prevent="submit">

      <md-card
        class="auth-page__card
               md-layout-item
               md-size-30
               md-large-size-45
               md-medium-size-55
               md-small-size-75
               md-xsmall-size-100">
        <md-progress-bar md-mode="indeterminate" v-if="isPending"/>

        <md-card-header>
          <div class="text_xl_large">{{ i18n.su_sign_up() }}</div>
        </md-card-header>


        <md-card-content>
          <input-field class="input-field"
                       id="login-email"
                       name="email"
                      :label="i18n.su_email()"
                      :errorMessage="errorMessage('email')"
                     v-model.trim="form.email"
                     v-validate="'required|email'"
          />

          <input-field class="input-field"
                       id="login-password"
                       ref="password"
                       type="password"
                       name="password"
                      :togglePassword="true"
                      :label="i18n.su_pwd()"
                      :errorMessage="errorMessage('password')"
                      :data-vv-as="i18n.signup_password()"
                     v-model.trim="form.password"
                     v-validate="'required|min:6'"
          />

          <input-field class="input-field"
                       id="login-confirm-password"
                       type="password"
                       name="confirm-password"
                      :label="i18n.su_confirm()"
                      :togglePassword="true"
                      :errorMessage="errorMessage('confirm-password')"
                     v-model.trim="form.confirmPassword"
                     v-validate="'required|confirmed:password'"
                     :data-vv-as="i18n.signup_password()"
          />

          <div class="auth-page__bottom text_small">
            <div class="auth-page__tips">
              <div class="tips__tip">
                {{ i18n.su_already_have_an_account() }}
                <router-link :to="routes.login">{{ i18n.su_sign_in() }}</router-link>
              </div>
            </div>
          </div>

          <div class="btn-wrap margin-top">
            <md-button type="submit" class="btn md-primary md-yellow w-100" :disabled="isPending">
              {{ i18n.su_sign_up() }}
            </md-button>
          </div>

        </md-card-content>
      </md-card>
    </form>
  </div>
</template>

<script>
  import config from '@conf'
  import formMixin from '@com/mixins/form.mixin'

  import { ErrorFactory, errorTypes, errors } from '@js/errors/factory'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { vueRoutes } from '@router/const'
  import { Keypair } from 'tokend-js-sdk'
  import { showRememberSeedMessage } from '@js/modals/remember_seed.modal'
  import { mapActions, mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  import { emailService } from '@api/email.service'
  import { authService } from '@api/auth.service'
  import { i18n } from '@js/i18n'

  export default {
    mixins: [formMixin],

    data () {
      return {
        form: {
          email: '',
          password: '',
          confirmPassword: ''
        },
        url: '',
        routes: vueRoutes,
        i18n
      }
    },

    computed: {
      ...mapGetters([
        vuexTypes.getUserLocale
      ])
    },

    created () {
      this.url = this.getDocUrl()
    },

    methods: {
      ...mapActions({
        loadMaster: vuexTypes.GET_MASTER_ACCOUNT_ID
      }),

      async submit () {
        if (!await this.isValid()) return
        this.form.email = this.form.email.toLowerCase()
        this.form.email = this.form.email.trim()
        this.disable()
        try {
          await this.checkEmailValidity()
          await this.loadMaster()
          const recoveryKeypair = Keypair.random()
          const walletId = await authService.signup(this.form, recoveryKeypair)
          this.enable()
          await showRememberSeedMessage(recoveryKeypair.secret())
          this.goShowEmail(walletId)
        } catch (error) {
          switch (error.constructor) {
            case errors.ConflictError:
              error.showBanner(i18n.user_exists())
              break
            default:
              ErrorHandler.processUnexpected(error)
          }
          this.enable()
        }
      },

      async checkEmailValidity () {
        if (!config.VALIDATE_EMAILS) return Promise.resolve(true)

        const emailDetails = await emailService.validateOnMailgun(this.email)

        if (emailDetails.is_valid === false) {
          ErrorFactory.throwError(errorTypes.InvalidEmailError)
        }
        if (emailDetails.is_role_address) {
          ErrorFactory.throwError(errorTypes.RoleEmailError)
        }
        if (emailDetails.is_disposable_address) {
          ErrorFactory.throwError(errorTypes.DisposableEmailError)
        }
        return Promise.resolve(true)
      },

      goShowEmail (walletId) {
        const route = { ...vueRoutes.email, query: { walletId, email: this.form.email } }
        this.$router.push(route)
      },

      getDocUrl () {
        if (this.getUserLocale === 'ru') {
          return 'landing/documents/documents_ru.html#'
        } else if (this.getUserLocale === 'ua') {
          return 'landing/documents/documents_ua.html#'
        } else {
          return 'landing/documents/documents_en.html#'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'auth';
  .tips__tip {
    a {
      font-weight: bold;
    text-decoration: underline;
    color: $default-black;
    }

  }
  .w-100 {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/vue/auth/Signup.vue